<template>
  <div>
    <div class="ts-container ts-mx-auto ts-p-4 sm:ts-flex sm:ts-items-center sm:ts-justify-between">
      <div class="ts-flex ts-justify-between">
        <div class="ts-pl-3">
          <a href="#">
            <img class="ts-w-20 md:ts-w-24" src="@/assets/logo.png" alt="logo" />
          </a>
        </div>
        <button
          class="ts-outline-none focus:ts-outline-none sm:ts-hidden"
          @click.prevent="() => (isOpen = !isOpen)"
        >
          <svg height="30" width="30" viewBox="0 -53 384 384" v-if="!isOpen">
            <defs />
            <path
              d="M368 155H16a16 16 0 010-32h352a16 16 0 010 32zm0 0M368 32H16a16 16 0 010-32h352a16 16 0 010 32zm0 0M368 277H16a16 16 0 010-32h352a16 16 0 010 32zm0 0"
            />
          </svg>
          <svg viewBox="0 0 512 512" height="30" width="30" v-else>
            <defs />
            <path
              d="M284 256L506 34a20 20 0 10-28-28L256 228 34 6A20 20 0 106 34l222 222L6 478a20 20 0 1028 28l222-222 222 222a20 20 0 0028 0c8-8 8-20 0-28L284 256z"
            />
          </svg>
        </button>
      </div>
      <div>
        <div :class="isOpen ? 'ts-block' : 'ts-hidden'" class="sm:ts-hidden ts-mt-4">
          <ul class="ts-p-6 ts-rounded-lg" style="background:rgb(241,241,241)">
            <li class="ts-border-b ts-border-gray-300 ts-p-2">
              <a
                href="#"
                class="ts-text-heading-color ts-text-base ts-font-robot ts-tracking-wider hover:ts-text-maincolor hover:ts-no-underline ts-font-semibold ts-uppercase"
              >Home</a>
            </li>
            <li class="ts-border-b ts-border-gray-300 ts-px-2 ts-py-4">
              <a
                href="#"
                class="ts-text-heading-color ts-text-base ts-font-robot ts-tracking-wider hover:ts-text-maincolor hover:ts-no-underline ts-font-semibold ts-uppercase"
              >results</a>
            </li>
            <li class="ts-px-2 ts-py-4">
              <a
                href="#"
                class="ts-text-heading-color ts-text-base ts-font-robot ts-tracking-wider hover:ts-text-maincolor hover:ts-no-underline ts-font-semibold ts-uppercase"
              >about us</a>
            </li>
            <!-- <li>
              <button
                class="ts-bg-maincolor ts-text-white ts-font-robot ts-text-base ts-px-8 ts-py-3 ts-rounded-full ts-uppercase hover:ts-shadow-blue transition"
              >
                join us
              </button>
            </li>-->
          </ul>
        </div>
        <div class="ts-hidden sm:ts-block">
          <div class="sm:ts-flex sm:ts-items-center sm:ts-justify-end">
            <ul class="sm:ts-flex sm:ts-my-auto">
              <li>
                <router-link
                  to="/"
                  tag="a"
                  @click.prevent="$router.push({ name: 'home'})"
                  href="/"
                  :class="flag == 'kh' ? 'ts-font-koulen ts-font-medium' : 'ts-font-robot ts-font-semibold'"
                  class="ts-inline-block ts-text-heading-color ts-text-base ts-tracking-wider hover:ts-text-maincolor hover:ts-no-underline ts-px-8 ts-py-6 ts-uppercase"
                >{{ $t('menu.home') }}</router-link>
              </li>
              <li>
                <router-link
                  to="/results"
                  tag="a"
                  @click.prevent="$router.push({ name: 'result'})"
                  :class="flag == 'kh' ? 'ts-font-koulen ts-font-medium' : 'ts-font-robot ts-font-semibold'"
                  class="ts-inline-block ts-text-heading-color ts-text-base ts-tracking-wider hover:ts-text-maincolor hover:ts-no-underline ts-px-8 ts-py-6 ts-uppercase"
                >{{ $t('menu.result') }}</router-link>
              </li>
              <li>
                <router-link
                  to="/news"
                  tag="a"
                  @click.prevent="$router.push({ name: 'front-news'})"
                  :class="flag == 'kh' ? 'ts-font-koulen ts-font-medium' : 'ts-font-robot ts-font-semibold'"
                  class="ts-inline-block ts-text-heading-color ts-text-base ts-tracking-wider hover:ts-text-maincolor hover:ts-no-underline ts-px-8 ts-py-6 ts-uppercase"
                >{{ $t('menu.news') }}</router-link>
              </li>
              <li>
                <router-link
                  to="/about-us"
                  tag="a"
                  @click.prevent="$router.push({ name: 'front-about-us'})"
                  :class="flag == 'kh' ? 'ts-font-koulen ts-font-medium' : 'ts-font-robot ts-font-semibold'"
                  class="ts-inline-block ts-text-heading-color ts-text-base ts-tracking-wider hover:ts-text-maincolor hover:ts-no-underline ts-px-8 ts-py-6 ts-uppercase"
                >{{ $t('menu.aboutUs') }}</router-link>
              </li>
              <li class="dropdown navbar-language">
                <b-dropdown variant="link" menu-class="p-b-0" class="ts-h-full">
                  <template slot="button-content">
                    <span :class="`flag-icon flag-icon-${flag}`" :title="flag"></span>
                  </template>
                  <b-dropdown-item
                    href="#"
                    v-for="language in languages"
                    :key="language.code"
                    @click="changeLanguage(language)"
                  >
                    <span :class="`flag-icon flag-icon-${language.icon}`" :title="language.icon"></span>
                    {{ language.caption }}
                  </b-dropdown-item>
                </b-dropdown>
              </li>
            </ul>
            <!-- <div class="ts-ml-4 ts-hidden sm:ts-block">
              <button
                class="ts-bg-maincolor ts-text-white ts-font-robot ts-text-base ts-px-8 ts-py-3 ts-rounded-full ts-uppercase hover:ts-shadow-blue transition"
              >
                join us
              </button>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'headerBottom',
  data() {
    return {
      isOpen: false,
      languages: [
        { code: 'kh', icon: 'kh', caption: 'ខ្មែរ' },
        { code: 'en', icon: 'us', caption: 'English' }
      ]
    }
  },
  computed: {
    flag() {
      if (this.$root.$i18n.locale === 'kh') return 'kh'
      else if (this.$root.$i18n.locale === 'en') return 'us'
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$root.$i18n.locale = lang.code
      localStorage.setItem('langCode', lang.code)
    }
  }
}
</script>
<style lang="css" scoped>
.transition {
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
}
.router-link-exact-active {
  color: #33b5f7;
}
</style>
